import React, { useEffect, useRef } from "react"

export function openLinkedAnswer(root, hash) {
  let id
  try {
    id = decodeURIComponent(hash.slice(1))
  } catch (error) {
    return
  }
  if (!id || !root) return

  const target = root.ownerDocument.getElementById(id)
  if (!target || !root.contains(target)) return
  const item = target.closest("details.ig-accordion__item")
  if (!item) return

  item.open = true
  item.scrollIntoView({ block: "start" })
}

export default function Accordion({ children, ...attributes }) {
  const root = useRef(null)

  useEffect(() => {
    const reveal = () => openLinkedAnswer(root.current, window.location.hash)
    reveal()
    window.addEventListener("hashchange", reveal)
    return () => window.removeEventListener("hashchange", reveal)
  }, [])

  // Native details/summary owns disclosure state and works before hydration or
  // without JavaScript. Every answer is rendered into Gatsby's initial HTML.
  return (
    <div {...attributes} ref={root}>
      {children}
    </div>
  )
}
